import React from "react";

const Rules = () => {
  return (
    <div>
      <div className="heading_box" style={{ marginBottom: "4%" }}>
        <div>
          <p class="btn">
            <span>
              <span>
                <span className="border_box">The GAME</span>
              </span>
            </span>
          </p>
        </div>
        <div className="rules_content">
          <div style={{ marginTop: "3%" }}>
            <h1 className = "rule_title" style={{ marginBottom: "2%" }}>
              What is this all about and what it aims to do?
            </h1>
            <ul>
              <li>
                Density is here to hire the best brains to work on our one of
                the most ambitious projects based on blockchain technology. We
                ought to conduct this hackathon to find the best in you and also
                to give you the opportunity to think on the best market options
                you can upskill.
              </li>
            </ul>
          </div>
          <div style={{ marginTop: "3%" }}>
            <h1 className = "rule_title" style={{ marginBottom: "2%" }}>
              About hackathon and its organisation
            </h1>
            <ul>
              <li>
                Hackathon participation can be done in teams of a minimum of 2
                members and a maximum of 5. If you are not able to make a team,
                you can still fill out the form and we will make a team for you.
              </li>
              <li>
                The Hackathon is going to be of around 36 hours starting on 28th
                Friday eve.
              </li>
              <li>
                Judging rounds will comprise of the middle continuous
                evaluation, final pitching of projects and personal interviews
                for everyone
              </li>
              <li>
                It’s not about the result but also your approach, strategy and
                overall outcome.
              </li>
              <li>
                If for any reason you cannot participate in the hackathon but
                still wanna interview for the internship, you can register in
                the form as well. (This is not a recommended way)
              </li>
            </ul>
          </div>
          <div style={{ marginTop: "3%" }}>
            <h1 className = "rule_title" style={{ marginBottom: "2%" }}>Problem statement</h1>
            <ul>
              <li>
                Problem statements will revolve around Web2 and some Web3. It’s
                most part will require you to code the frontend and backend of
                the application based on your creative solution and strategy.
                You do not require any prior knowledge of web3 and blockchain.
                What you require is the knowledge of frontend development in
                react, backend of your choice, some UI/UX and good collaboration
                among these
              </li>
              <li>Link to Problem Statement : <a target="_blank" href="https://docs.google.com/document/d/1t3Qjr0OdNxVbR4sE87CxXnCM6AgRTGyUoKzCKicjvF8/edit" style={{color: "skyblue"}}>PS : Hack-an-Intern</a></li>
            </ul>
          </div>
          <div style={{ marginTop: "3%" }}>
            <h1 className = "rule_title" style={{ marginBottom: "2%" }}>Skills required</h1>
            <ul>
              <li>Good coding skills</li>
              <li>Frontend: React-redux (somewhat necessary)</li>
              <li>
                Backend: Go-lang/C++ (preferably) or any language of your
                choice.
              </li>
              <li>UI/UX: A bit of your creativity, nothing else.</li>
              <li>Blockchain: No prior knowledge is required.</li>
            </ul>
          </div>
        </div>
        <div style={{ marginTop: "70px" }}>
          <h4
            style={{ width: "100%", textAlign: "center" }}
            className="page3_subtitle text3"
          >
            -----Abide by them strictly-----
          </h4>
        </div>
      </div>
    </div>
  );
};

export default Rules;
